module.exports = __webpack_public_path__ + "img/7.bab8929d.jpg";